module.exports = __webpack_public_path__ + "static/img/MZ.2a76d4b0.svg";